module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/1/3-8c70795741cf438138f79e590f40a657.jpg";